import '../styles/main.scss';

import App from "./App.js"

window.addEventListener(
  "load",
  function () {
    gsap.registerPlugin(Draggable, InertiaPlugin, ScrollTrigger, SplitText);
    window.app = new App();
  },
  false
);
